import React, { useEffect, useState, memo } from 'react';
import { has } from 'lodash';
import { useParams } from 'react-router-dom';

import AutoComplete from 'components/ui/AutoComplete';
import { InputAdornment, TextField } from '@material-ui/core';
import { getService, getServices } from 'api/service';

const Service = memo(
  ({
    service,
    serviceId,
    serviceDuration,
    estimatedParticipants,
    actualParticipants,
    touched,
    errors,
    handleChange,
    setFieldValue,
    clinicServiceDuration,
  }) => {
    const { id } = useParams();

    const [services, setServices] = useState([]);
    const [newServiceDuration, setNewServiceDuration] = useState();

    useEffect(async () => {
      const { data } = await getServices(0, 10000);

      setServices(data.data);
    }, []);

    useEffect(async () => {
      if (typeof serviceId === 'number') {
        const {
          data: { default_duration: defaultDuration },
        } = await getService(serviceId);

        setNewServiceDuration(defaultDuration);
      }
    }, [serviceId]);

    useEffect(() => {
      if (!clinicServiceDuration) {
        setFieldValue('serviceDuration', newServiceDuration);
      }
    }, [newServiceDuration, clinicServiceDuration]);

    return (
      <>
        <AutoComplete
          data={services}
          label="Service"
          name="serviceId"
          setFieldValue={setFieldValue}
          value={serviceId}
          groupBy="name"
          getOptionLabel={({ name }) => name || ''}
          selection={service}
          error={touched.serviceId && has(errors, 'serviceId')}
          touched={touched}
          required
          bottom="-1"
        />

        <TextField
          label="Service Duration"
          InputProps={{
            endAdornment: <InputAdornment position="end">Mins</InputAdornment>,
            step: 5,
          }}
          name="serviceDuration"
          error={touched.serviceDuration && has(errors, 'serviceDuration')}
          helperText={touched.serviceDuration && errors.serviceDuration}
          onChange={handleChange}
          variant="outlined"
          value={serviceDuration}
          type="number"
          required
        />

        <TextField
          color="primary"
          error={
            touched.estimatedParticipants &&
            has(errors, 'estimatedParticipants')
          }
          helperText={
            touched.estimatedParticipants && errors.estimatedParticipants
          }
          label="Estimated Participants"
          name="estimatedParticipants"
          onChange={handleChange}
          value={estimatedParticipants}
          variant="outlined"
          type="number"
        />

        {id && (
          <TextField
            color="primary"
            error={
              touched.actualParticipants && has(errors, 'actualParticipants')
            }
            helperText={touched.actualParticipants && errors.actualParticipants}
            label="Actual Participants"
            name="actualParticipants"
            onChange={handleChange}
            value={actualParticipants}
            variant="outlined"
            type="number"
          />
        )}
      </>
    );
  },
);

export default Service;
